import { useEffect } from 'react';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useIsAuthenticated
} from '@azure/msal-react';
import useRequestAccessToken from './useRequestAccessToken';

import { MicrosoftSignInButton } from 'src/components/buttons/login/MicrosoftSignInButton';
import { HelmetProvider } from 'react-helmet-async';
import App from '../App';

export function App2() {
  const isAuthenticated = useIsAuthenticated();
  const getAccessToken = useRequestAccessToken();
  useEffect(() => {
    // debugger;
    if (isAuthenticated) {
      getAccessToken();
    }
  }, [isAuthenticated]);

  return (
    <>
      <AuthenticatedTemplate>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <MicrosoftSignInButton />
      </UnauthenticatedTemplate>
    </>
  );
}
